export default __webpack_public_path__ + "static/media/newMessage.c33eba38.mp3";